<template>
    <div
        class="flex flex-col items-center justify-center flex-grow w-full mx-10"
    >
        <component
            ref="transportation"
            v-for="(transportation, index) in transportationCards"
            :key="transportation.key"
            :is="transportation.model"
            :data="transportation.object"
            v-on:remove="removeTransportation($event, index)"
        />
        <base-add-button
            title="Ajouter Moyens de transports et manutentions"
            @click="pushArray"
        />
        <div class="grid items-center justify-center w-full grid-cols-10 ">
            <base-primary-button
                title="Suivant"
                @click="nextStep"
                class="w-full col-span-6 col-start-3"
            />
            <div
                @click="skipStep"
                class="flex items-center justify-center col-span-2 col-start-9 p-3 mb-6 space-x-2 text-gray-500 cursor-pointer hover:underline hover:text-gray-800 "
            >
                <span>Ignorer cette étape</span>
                <svg
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 5l7 7-7 7M5 5l7 7-7 7"
                    ></path>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import TransportationCard from "./components/TransportationCard";
import { mapState } from "vuex";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        TransportationCard
    },
    data() {
        return {
            transportationCards: []
        };
    },
    mixins: [scrollToError],
    mounted() {
        this.transportationCards = this.$store.getters[
            "EtudeTechnique/getTransportation"
        ];
        this.$store.dispatch(
            "forms/currentStep",
            "Moyens de transports et manutentions"
        );
    },

    methods: {
        pushArray() {
            if (!this.checkForms()) {
                this.transportationCards.push({
                    model: "transportation-card",
                    key: new Date().getTime(),
                    object: {
                        id: new Date().getTime(),
                        BuyingType: "achat",
                        designation: "",
                        number: 1,
                        characteristics: "",
                        state: "",
                        price: null,
                        providerName: "",
                        origin: "",
                        payedInAdvance: null,
                        rentPrice: null,
                        rentDuration: null
                    }
                });

                this.$refs.transportation[
                    this.$refs.transportation.length - 1
                ].scrollToRef();
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        skipStep() {
            this.$router.push({
                name: "mobilier_et_bureaux",
                params: { uid: `${this.$store.state.user.bpiId}` }
            });
        },
        checkForms() {
            let formsHasError = false;
            this.$refs.transportation.forEach(item => {
                if (!item.createTransportation()) {
                    formsHasError = true;
                }
            });
            return formsHasError;
        },
        nextStep() {
            if (!this.checkForms() && this.transportationLength >= 1) {
                this.$store.dispatch("EtudeTechnique/SaveTransportation");

                this.$router.push({
                    name: "mobilier_et_bureaux",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        removeTransportation(payload, index) {
            this.$store.dispatch(
                "EtudeTechnique/removeTransportation",
                payload
            );
            this.transportationCards.splice(index, 1);
        }
    },
    computed: {
        ...mapState("EtudeTechnique", {
            transportationLength: state => state.transportation.length
        })
    }
};
</script>

<style></style>
